import { render, staticRenderFns } from "./DataCollectionSheet.vue?vue&type=template&id=03187730"
import script from "./DataCollectionSheet.vue?vue&type=script&lang=ts"
export * from "./DataCollectionSheet.vue?vue&type=script&lang=ts"
import style0 from "./DataCollectionSheet.vue?vue&type=style&index=0&id=03187730&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports